import React, { useState, Suspense, lazy, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import Card from "react-bootstrap/Card";
import Modal from "react-bootstrap/Modal";
import ReactLoading from "react-loading";
import Alert from "react-bootstrap/Alert";
import DateRangePicker from "../../DatePickers/DateRangePicker/DateRangePicker";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";
import Form from "react-bootstrap/Form";
import { InternalAlertsParser } from "../../../parser/Alerts";

import DeploymentApi from "../../../api/DeploymentsApi";
import AlertsAPI from "../../../api/Alerts";

const { SearchBar, ClearSearchButton } = Search;

export default function DeploymentsTab() {
    const token = Cookies.get("Session");

    const dispatch = useDispatch();

    const {
        selectedCustomer,
        selectedFacility,
        selectedEquipment,
        equipmentTimezone,
        customerList,
        equipmentsList,
        equipmentStartDate,
    } = useSelector((state) => state.equipmentsPortfolio);

    const [activeAlertsRows, setActiveAlertsRows] = useState([]);
    const activeAlertsColumns = [
        { dataField: "date", text: "Time", sort: true },
        { dataField: "subject", text: "Alert", sort: true },
        {
            dataField: "complete",
            isDummyField: true,
            text: "Complete",
            sort: false,
            formatter: (cell, row, rowIndex, extraData) => {
                return (
                    <Button
                        onClick={() => {
                            onCompleteButtonClick(row);
                        }}
                    >
                        Complete
                    </Button>
                );
            },
        },
    ];

    const [activeAlert, setActiveAlert] = useState({ color: "blue", text: "", show: false });

    const [completeAlertsTable, setCompleteAlertsTable] = useState(InternalAlertsParser.completeAlertsTable([]));
    const [completeAlert, setCompleteAlert] = useState({ color: "blue", text: "", show: false });

    const [isActiveLoading, setIsActiveLoading] = useState(false);
    const [isCompleteLoading, setIsCompleteLoading] = useState(false);

    useEffect(() => {
        if (customerList.length != 0) {
            getAlerts();
        }
    }, [customerList]);

    const onReloadButtonClick = () => {
        if (customerList.length != 0) {
            getAlerts();
        }
    };

    const getAlerts = () => {
        setIsActiveLoading(true);
        setIsCompleteLoading(true);

        DeploymentApi.getAlerts(token)
            .then((response) => {
                setIsActiveLoading(false);
                setIsCompleteLoading(false);

                if (response.status === 200) {
                    const alerts = response.data.content ?? [];

                    setActiveAlertsRows(InternalAlertsParser.activeAlertsTable(alerts));
                    setCompleteAlertsTable(InternalAlertsParser.completeAlertsTable(alerts));
                }
            })
            .catch((error) => {
                console.error("Error fetching alerts:", error);
                setActiveAlert({ color: "red", text: "Error fetching active alerts.", show: true });
                setCompleteAlert({ color: "red", text: "Error fetching complete alerts.", show: true });
                setIsActiveLoading(false);
                setIsCompleteLoading(false);
            });
    };

    const onCompleteButtonClick = (row) => {
        const activeAlerts = activeAlertsRows.filter((alert) => alert.id != row.id);
        const completeAlerts = completeAlertsTable.rows.concat(row);

        setActiveAlertsRows(activeAlerts);
        setCompleteAlertsTable({ ...completeAlertsTable, rows: completeAlerts });
        setActiveAlert({ color: "blue", text: "Alert completed successfully.", show: true });
        DeploymentApi.patchComplete(token, row.id)
            .then((response) => {
                if (response.status === 200) {
                    setCompleteAlert({ color: "green", text: "Alert marked as complete.", show: true });
                } else {
                    setCompleteAlert({ color: "red", text: "Error marking alert as complete.", show: true });
                }
            })
            .catch((error) => {
                console.error("Error marking alert as complete:", error);
                setCompleteAlert({ color: "red", text: "Error marking alert as complete.", show: true });
            });
    };

    return (
        <div>
            <Card>
                <Card.Body>
                    <Row className="mt-3">
                        {/************************************************* Sub Menu Tabs **********************************************************************/}
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Tabs variant="pills">
                                        {/************************************************* Active Tab **********************************************************************/}
                                        <Tab eventKey="Active" title="Active">
                                            <Row className="mt-4">
                                                <Col>
                                                    <Card>
                                                        <Card.Header>
                                                            <h4>Active Alerts</h4>
                                                        </Card.Header>

                                                        <Card.Body>
                                                            <Row className="mt-3">
                                                                <Col className="alertsTable first-col-width last-col-width">
                                                                    <ToolkitProvider
                                                                        keyField="id"
                                                                        data={activeAlertsRows}
                                                                        columns={activeAlertsColumns}
                                                                        search
                                                                        bootstrap4
                                                                    >
                                                                        {(props) => (
                                                                            <div>
                                                                                <Row>
                                                                                    <Col className="col-2">
                                                                                        <SearchBar
                                                                                            {...props.searchProps}
                                                                                        />
                                                                                    </Col>

                                                                                    <Col className="col-1">
                                                                                        <ClearSearchButton
                                                                                            className="btn-primary btn_alert"
                                                                                            {...props.searchProps}
                                                                                        />
                                                                                    </Col>
                                                                                    <Col className="col-6">
                                                                                        <Alert
                                                                                            variant={activeAlert.color}
                                                                                            show={activeAlert.show}
                                                                                            onClose={() =>
                                                                                                setActiveAlert({
                                                                                                    ...activeAlert,
                                                                                                    show: false,
                                                                                                })
                                                                                            }
                                                                                            dismissible
                                                                                        >
                                                                                            {activeAlert.text}
                                                                                        </Alert>
                                                                                    </Col>
                                                                                    <Col className="mt-2 mb-2 col-1 offset-2">
                                                                                        {isActiveLoading ? (
                                                                                            <ReactLoading
                                                                                                type="bars"
                                                                                                height={50}
                                                                                                width={50}
                                                                                                color="#007bff"
                                                                                            />
                                                                                        ) : (
                                                                                            <Button
                                                                                                className="btn_alert"
                                                                                                onClick={
                                                                                                    onReloadButtonClick
                                                                                                }
                                                                                            >
                                                                                                Reload
                                                                                            </Button>
                                                                                        )}
                                                                                    </Col>
                                                                                </Row>
                                                                                <div className="eventSearchBox_ctn"></div>

                                                                                <BootstrapTable
                                                                                    className="active-alerts-table"
                                                                                    {...props.baseProps}
                                                                                    noDataIndication="No Alerts Found"
                                                                                />
                                                                            </div>
                                                                        )}
                                                                    </ToolkitProvider>
                                                                </Col>
                                                            </Row>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </Tab>
                                        {/************************************************* Complete Alerts Tab **********************************************************************/}

                                        <Tab eventKey="Completed" title="Completed">
                                            <Row className="mt-4">
                                                <Col>
                                                    <Card>
                                                        <Card.Header>
                                                            <h4>Completed Alerts</h4>
                                                        </Card.Header>

                                                        <Card.Body>
                                                            <Row className="mt-3">
                                                                <Col className="alertsTable first-col-width last-col-width">
                                                                    {completeAlertsTable.columns.length ? (
                                                                        <ToolkitProvider
                                                                            keyField="id"
                                                                            data={completeAlertsTable.rows}
                                                                            columns={completeAlertsTable.columns}
                                                                            search
                                                                            bootstrap4
                                                                        >
                                                                            {(props) => (
                                                                                <div>
                                                                                    <Row>
                                                                                        <Col className="col-2">
                                                                                            <SearchBar
                                                                                                {...props.searchProps}
                                                                                            />
                                                                                        </Col>

                                                                                        <Col className="col-1">
                                                                                            <ClearSearchButton
                                                                                                className="btn-primary btn_alert"
                                                                                                {...props.searchProps}
                                                                                            />
                                                                                        </Col>
                                                                                        <Col className="col-6">
                                                                                            <Alert
                                                                                                variant={
                                                                                                    completeAlert.color
                                                                                                }
                                                                                                show={
                                                                                                    completeAlert.show
                                                                                                }
                                                                                                onClose={() =>
                                                                                                    setCompleteAlert({
                                                                                                        ...completeAlert,
                                                                                                        show: false,
                                                                                                    })
                                                                                                }
                                                                                                dismissible={true}
                                                                                            >
                                                                                                {completeAlert.text}
                                                                                            </Alert>
                                                                                        </Col>
                                                                                        <Col className="mt-2 mb-2 col-1 offset-2">
                                                                                            {isCompleteLoading ? (
                                                                                                <ReactLoading
                                                                                                    type="bars"
                                                                                                    height={50}
                                                                                                    width={50}
                                                                                                    color="#007bff"
                                                                                                />
                                                                                            ) : (
                                                                                                <Button
                                                                                                    className="btn_alert"
                                                                                                    onClick={
                                                                                                        onReloadButtonClick
                                                                                                    }
                                                                                                >
                                                                                                    Reload
                                                                                                </Button>
                                                                                            )}
                                                                                        </Col>
                                                                                    </Row>
                                                                                    <div className="eventSearchBox_ctn"></div>

                                                                                    <BootstrapTable
                                                                                        {...props.baseProps}
                                                                                        noDataIndication="No Alerts Found"
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                        </ToolkitProvider>
                                                                    ) : null}
                                                                </Col>
                                                            </Row>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </Tab>
                                    </Tabs>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            <br></br>
        </div>
    );
}
